import { get, post } from '@/httpRequest/http'
const { VUE_APP_NEWS = '' } = process.env
import { getBaseUrl } from '@/utils'
const NewsBaseUrl = getBaseUrl(VUE_APP_NEWS)

export const getDetail = params => {
    return get(`${NewsBaseUrl}/news/v2/detail`, { params, noEncTag: true, encrypt: 0 })
}

export const getAboutList = data => {
    return post(`${NewsBaseUrl}/news/v2/stock/related`, { data, noEncTag: true, encrypt: 0 })
}

export const userEvent = data => {
    return post(`${NewsBaseUrl}/news/v2/userEvent/read/upd`, { data, noEncTag: true, encrypt: 0 })
}
